import React from 'react';
import ColorPicker from 'react-pick-color';

const ColorPickerComponent = ({ handleColor, color }) => {
    return <ColorPicker color={color} onChange={handleColor} />;
};
export default ColorPickerComponent;